// Gate that blocks brownfield deeplink/URL navigation until any in-progress
// updateLocation saga (which may be showing the OS location permission dialog)
// has finished. Reference-counted so concurrent updateLocation calls are safe.

let refCount = 0
let pending: Promise<void> | null = null
let resolvePending: (() => void) | null = null

export function acquireLocationUpdateGate(): void {
  refCount++
  if (!pending) {
    pending = new Promise<void>((resolve) => {
      resolvePending = resolve
    })
  }
}

export function releaseLocationUpdateGate(): void {
  refCount = Math.max(0, refCount - 1)
  if (refCount === 0) {
    resolvePending?.()
    pending = null
    resolvePending = null
  }
}

export function waitForLocationUpdateGate(): Promise<void> {
  if (!pending) return Promise.resolve()
  return pending
}
